<template>
  <v-app>
    <div v-if="loading">
      <v-alert
        v-if="notAdminError"
        :value="true"
        type="error"
        transition="scale-transition"
      >
        У вас немає доступу до цієї сторінки
      </v-alert>
      <v-alert
        v-else-if="error"
        :value="true"
        type="error"
        transition="scale-transition"
      >
        Виникла помилка! Подробиці в консолі розробника.
      </v-alert>
    </div>
    <div v-else-if="!error && !notAdminError">
      <NavBar/>
      <v-content class="app__content">
        <router-view />
      </v-content>
      <Footer/>
    </div>
  </v-app>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import status_codes from "@/config/status-codes";
import {urls} from "@/config";
import Footer from "./components/Footer";

export default {
  name: 'App',
  components: {
    Footer,
    NavBar
  },
  data () {
    return {
      loading: false,
      notAdminError: false,
      error: false
    }
  },
  async created() {
    try {
      this.loading = true;
      const userId = this.$route.params.id || 0;
      await this.$store.dispatch("checkAccess", {userId});
      this.loading = false
    } catch (e) {
      switch (e.code) {
        case status_codes.UNAUTHORIZED:
          window.location.href = urls.signin;
          break;
        case status_codes.ACCESS_DENIED:
          console.log("not admin");
          this.error = true;
          this.notAdminError = true;
          break;
        default:
          console.warn({e});
          this.error = true;
      }
    }
  }
}
</script>

<style>
  .app__content {
    min-height: calc(100vh - 60px);
  }

  .application--wrap {
    background-color: #444444;
  }

  html {
    overflow-y: auto !important;
  }
</style>
